document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
  }
});

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-variant-select]');
  if (!selector) return;
  const option = selector.options[selector.selectedIndex];
  const productRoot = selector.closest('[data-product-root]');
  const price = productRoot.querySelector('[data-product-price]');
  const button = productRoot.querySelector('[data-add-to-cart]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldLabel;
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-ajax-product-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[data-add-to-cart]');
  const original = button.textContent;
  button.disabled = true;
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart error');
    button.textContent = button.dataset.addedLabel;
    document.dispatchEvent(new CustomEvent('cart:updated'));
    setTimeout(() => { button.textContent = original; button.disabled = false; }, 1500);
  } catch (error) {
    button.textContent = button.dataset.errorLabel;
    setTimeout(() => { button.textContent = original; button.disabled = false; }, 1800);
  }
});
